<template>
  <div class="multiEventoPage">
    <header class="multiEventoToolbar">
      <div class="multiEventoTitle">
        <i class="fa fa-th-large" aria-hidden="true"></i>
        <strong>Multi-eventos</strong>
      </div>

      <multi-evento-selector
        v-model="estado.principalId"
        class="multiEventoPrincipalSelector"
        :eventos="eventos"
        placeholder="Selecionar evento principal"
        @change="salvar"
      />

      <button
        type="button"
        class="multiEventoNovaJanela"
        title="Adicionar janela"
        aria-label="Adicionar janela de evento"
        @click="adicionarJanela"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span>Janela</span>
      </button>

      <button
        type="button"
        class="multiEventoAtualizar"
        :disabled="carregando"
        title="Atualizar eventos"
        aria-label="Atualizar eventos"
        @click="carregarEventos"
      >
        <i
          class="fa fa-refresh"
          :class="{ 'fa-spin': carregando }"
          aria-hidden="true"
        ></i>
      </button>
    </header>

    <main class="multiEventoStage">
      <transition name="multiEventoPrincipal" mode="out-in">
        <evento-floating-player
          v-if="estado.principalId"
          :key="estado.principalId"
          class="multiEventoPrincipalPlayer"
          :evento-id="estado.principalId"
          :muted="false"
        />
        <div v-else key="vazio" class="multiEventoVazio">
          <i class="fa fa-television" aria-hidden="true"></i>
          <strong>Selecione o evento principal</strong>
        </div>
      </transition>
    </main>

    <floating-content-panel
      v-for="(janela, indice) in estado.janelas"
      :key="janela.id"
      class="multiEventoFloatingPanel"
      :title="nomeEvento(janela.eventoId)"
      icon-class="fa fa-television"
      :storage-key="geometriaKey(janela.id)"
      :initial-x="posicaoInicialX(indice)"
      :initial-y="posicaoInicialY(indice)"
      :initial-width="520"
      :initial-height="338"
      :z-index="1060 + indice"
      @close="removerJanela(janela.id)"
    >
      <button
        slot="actions"
        type="button"
        :disabled="!janela.eventoId"
        :title="janela.editando ? 'Ocultar seleção' : 'Trocar evento'"
        :aria-label="janela.editando ? 'Ocultar seleção' : 'Trocar evento'"
        @click.stop="alternarSelecao(janela)"
      >
        <i class="fa fa-exchange" aria-hidden="true"></i>
      </button>
      <button
        slot="actions"
        type="button"
        :disabled="!janela.eventoId"
        :title="janela.mudo ? 'Ativar áudio' : 'Silenciar'"
        :aria-label="janela.mudo ? 'Ativar áudio' : 'Silenciar evento'"
        @click.stop="alternarAudio(janela)"
      >
        <i
          class="fa"
          :class="janela.mudo ? 'fa-volume-off' : 'fa-volume-up'"
          aria-hidden="true"
        ></i>
      </button>
      <button
        slot="actions"
        type="button"
        :disabled="!janela.eventoId"
        title="Tornar evento principal"
        aria-label="Tornar evento principal"
        @click.stop="tornarPrincipal(janela)"
      >
        <i class="fa fa-thumb-tack" aria-hidden="true"></i>
      </button>

      <div
        class="multiEventoJanelaConteudo"
        :class="{ comSeletor: !janela.eventoId || janela.editando }"
      >
        <multi-evento-selector
          v-if="!janela.eventoId || janela.editando"
          v-model="janela.eventoId"
          :eventos="eventos"
          placeholder="Selecionar evento desta janela"
          @change="selecionarEventoJanela(janela)"
        />
        <transition name="multiEventoJanela" mode="out-in">
          <evento-floating-player
            v-if="janela.eventoId"
            :key="janela.eventoId"
            :evento-id="janela.eventoId"
            :muted="janela.mudo"
          />
          <div v-else key="vazio" class="multiEventoJanelaVazia">
            <i class="fa fa-plus-square-o" aria-hidden="true"></i>
            <span>Selecione um evento</span>
          </div>
        </transition>
      </div>
    </floating-content-panel>

    <div v-if="erro" class="multiEventoErro">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      {{ erro }}
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import EventoFloatingPlayer from "@/components/EventoFloatingPlayer.vue";
import FloatingContentPanel from "@/components/FloatingContentPanel.vue";
import MultiEventoSelector from "@/components/MultiEventoSelector.vue";
import {
  carregarMultiWorkspace,
  criarMultiJanela,
  gerarMultiWorkspaceId,
  multiWorkspaceStorageKey,
  salvarMultiWorkspace,
} from "@/services/multiEvento.js";

export default {
  name: "MultiEvento",
  components: {
    EventoFloatingPlayer,
    FloatingContentPanel,
    MultiEventoSelector,
  },
  data() {
    return {
      workspaceId: "",
      estado: {
        principalId: "",
        janelas: [],
      },
      eventos: [],
      carregando: false,
      erro: "",
      intervalo: null,
      documentoAnterior: null,
    };
  },
  mounted() {
    this.workspaceId = this.$route.query.workspace || gerarMultiWorkspaceId();
    if (!this.$route.query.workspace) {
      this.$router.replace({
        name: "multi",
        query: { workspace: this.workspaceId },
      });
    }

    this.estado = carregarMultiWorkspace(this.workspaceId);
    const app = document.getElementById("app");
    this.documentoAnterior = {
      title: document.title,
      backgroundColor: document.body.style.backgroundColor,
      overflow: document.body.style.overflow,
      appMarginTop: app ? app.style.marginTop : "",
    };
    document.title = "Multi-eventos";
    document.body.style.backgroundColor = "#070a0c";
    document.body.style.overflow = "hidden";
    if (app) {
      app.style.marginTop = "0";
    }

    this.salvar();
    this.carregarEventos();
    this.intervalo = setInterval(this.carregarEventos, 30000);
  },
  beforeDestroy() {
    clearInterval(this.intervalo);
    if (this.documentoAnterior) {
      document.title = this.documentoAnterior.title;
      document.body.style.backgroundColor =
        this.documentoAnterior.backgroundColor;
      document.body.style.overflow = this.documentoAnterior.overflow;
      const app = document.getElementById("app");
      if (app) {
        app.style.marginTop = this.documentoAnterior.appMarginTop;
      }
    }
  },
  methods: {
    async carregarEventos() {
      if (this.carregando) {
        return;
      }
      this.carregando = true;
      this.erro = "";

      try {
        const tipoUsuario = this.$sessao.usuario.tipoUsuario;
        const rota = tipoUsuario === "Assinante" ? "/evento/cache" : "/evento";
        const response = await api.get(rota + "?_limit=600");
        api.valid(response.data, this.$router);

        const podeVerTodos =
          tipoUsuario === "Administrador" ||
          tipoUsuario === "Administrador Site" ||
          tipoUsuario === "Apresentador";
        this.eventos = (response.data.itens || [])
          .filter(
            (evento) =>
              evento.site !== "Extra" &&
              (evento.situacao == 3 || podeVerTodos)
          )
          .map((evento) => ({
            id: evento._id,
            nome: evento.nome || "Evento sem nome",
            competicao: evento.competicao || "",
          }))
          .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));
        this.salvar();
      } catch (error) {
        this.erro = "Não foi possível carregar os eventos.";
      } finally {
        this.carregando = false;
      }
    },
    adicionarJanela() {
      this.estado.janelas.push(criarMultiJanela(this.estado.janelas.length));
      this.salvar();
    },
    removerJanela(janelaId) {
      this.estado.janelas = this.estado.janelas.filter(
        (janela) => janela.id !== janelaId
      );
      this.salvar();
    },
    alternarAudio(janela) {
      janela.mudo = !janela.mudo;
      this.salvar();
    },
    alternarSelecao(janela) {
      janela.editando = !janela.editando;
      this.salvar();
    },
    selecionarEventoJanela(janela) {
      janela.editando = false;
      this.salvar();
    },
    tornarPrincipal(janela) {
      if (!janela.eventoId) {
        return;
      }

      const principalAnterior = this.estado.principalId;
      this.estado.principalId = janela.eventoId;
      janela.eventoId = principalAnterior;
      janela.mudo = true;
      this.salvar();
    },
    salvar() {
      const principal = this.eventos.find(
        (evento) => evento.id === this.estado.principalId
      );
      this.estado = salvarMultiWorkspace(this.workspaceId, this.estado, {
        nome: principal ? principal.nome : "Workspace sem evento principal",
        usuarioKey:
          this.$sessao && this.$sessao.usuario
            ? this.$sessao.usuario._id || this.$sessao.usuario.email
            : "",
      });
    },
    geometriaKey(janelaId) {
      return multiWorkspaceStorageKey(this.workspaceId, janelaId);
    },
    nomeEvento(eventoId) {
      const evento = this.eventos.find((item) => item.id === eventoId);
      return evento ? evento.nome : "Selecionar evento";
    },
    posicaoInicialX(indice) {
      return 18 + (indice % 5) * 34;
    },
    posicaoInicialY(indice) {
      return 70 + (indice % 5) * 34;
    },
  },
};
</script>

<style>
.multiEventoPage {
  background: #070a0c;
  color: #eef2f3;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.multiEventoToolbar {
  align-items: center;
  background: #151c20;
  border-bottom: 1px solid #3d494f;
  display: grid;
  gap: 10px;
  grid-template-columns: auto minmax(220px, 520px) auto 38px;
  height: 58px;
  padding: 0 12px;
  position: relative;
  z-index: 1050;
}

.multiEventoTitle {
  align-items: center;
  display: inline-flex;
  font-size: 12px;
  gap: 8px;
  padding-right: 4px;
}

.multiEventoTitle i {
  color: #43bd89;
}

.multiEventoPrincipalSelector {
  max-width: 520px;
}

.multiEventoNovaJanela,
.multiEventoAtualizar {
  align-items: center;
  background: #263137;
  border: 1px solid #4a585f;
  color: #edf1f3;
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  gap: 7px;
  height: 36px;
  justify-content: center;
  padding: 0 11px;
}

.multiEventoNovaJanela:hover,
.multiEventoAtualizar:hover {
  background: #344149;
}

.multiEventoNovaJanela i {
  color: #4fc695;
}

.multiEventoAtualizar {
  padding: 0;
  width: 38px;
}

.multiEventoStage {
  background: #000000;
  height: calc(100% - 58px);
  overflow: hidden;
  position: relative;
}

.multiEventoPrincipalPlayer,
.multiEventoStage > .eventoFloatingPlayer {
  height: 100%;
  width: 100%;
}

.multiEventoVazio {
  align-items: center;
  color: #87949a;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  justify-content: center;
}

.multiEventoVazio i {
  font-size: 34px;
}

.multiEventoVazio strong {
  font-size: 12px;
  font-weight: 500;
}

.multiEventoJanelaConteudo {
  background: #070a0c;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  height: 100%;
  overflow: visible;
  padding: 6px;
  position: relative;
}

.multiEventoJanelaConteudo.comSeletor {
  grid-template-rows: 42px minmax(0, 1fr);
}

.multiEventoJanelaConteudo > .eventoFloatingPlayer {
  height: 100%;
  min-height: 0;
}

.multiEventoJanelaVazia {
  align-items: center;
  background: #090d0f;
  color: #8c999f;
  display: flex;
  font-size: 10px;
  gap: 8px;
  justify-content: center;
}

.multiEventoFloatingPanel .floatingContentPanelBody {
  overflow: visible;
}

.multiEventoFloatingPanel .floatingContentPanelActions button:disabled {
  cursor: default;
  opacity: 0.35;
}

.multiEventoPrincipal-enter-active,
.multiEventoPrincipal-leave-active,
.multiEventoJanela-enter-active,
.multiEventoJanela-leave-active {
  transition: opacity 0.18s ease;
}

.multiEventoPrincipal-enter,
.multiEventoPrincipal-leave-to,
.multiEventoJanela-enter,
.multiEventoJanela-leave-to {
  opacity: 0;
}

.multiEventoErro {
  align-items: center;
  background: #772e32;
  bottom: 12px;
  color: #ffffff;
  display: inline-flex;
  font-size: 10px;
  gap: 7px;
  left: 50%;
  padding: 9px 12px;
  position: fixed;
  transform: translateX(-50%);
  z-index: 1300;
}

@media (max-width: 640px) {
  .multiEventoToolbar {
    gap: 6px;
    grid-template-columns: minmax(0, 1fr) 38px 38px;
    height: 54px;
    padding: 0 7px;
  }

  .multiEventoTitle {
    display: none;
  }

  .multiEventoNovaJanela,
  .multiEventoAtualizar {
    height: 36px;
    padding: 0;
    width: 38px;
  }

  .multiEventoNovaJanela span {
    display: none;
  }

  .multiEventoStage {
    height: calc(100% - 54px);
  }
}
</style>
